<div class="body_wrap dashboard_body">
  <!-- <div class="sticky-top sticky-offset">
    <div class="top_menu">
      <button mat-button class="d-md-none d-none"><img src="../../assets/images/menu.svg" /></button>
    </div>
  </div> -->
  <div class="dash_base">
    <app-manage-saved-searches></app-manage-saved-searches>
  </div>
</div>
